import { SaveOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Select,
  Space,
  Typography
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Label } from '../../../components';
import CurrencyInputCustom from '../../../components/CurrencyInputCustom';
import LabelValidateMessage from '../../../components/LabelValidateMessage';
import ValidateMessage from '../../../components/ValidateMessage';
import {
  CANTIDAD_PAGOS_TODOS,
  // CANTIDAD_PAGOS_TODOS,
  FORMAS_EMISION,
  PERIODOS_CORTOS,
  UNIDAD_MEDIDA_FECHAS
} from '../../../constants';
import {
  currencyToNumber,
  errorHandler,
  formatNumberOnKeyPress,
  ordenarFrecuencias
} from '../../../utils';
import { instanceRef } from '../../../utils/axios';

const { Option } = Select;
const { Title } = Typography;

const backgroundColor = '#fafafa';
const border = '#f0f0f0';
const borderSolid = '#f0f0f0';

const tableTitleStyle = () => {
  const style = {
    padding: 8,
    width: '100%',
    maxWidth: 150,
    minWidth: 150,
    backgroundColor,
    borderBottom: `1px solid ${border}`,
    borderRight: `1px solid ${border}`
  };

  return style;
};

const OPCIONES_CANTIDAD_PROMOCION = [
  { codigo: 1, descripcion: '1 (Un) Pago' },
  { codigo: 2, descripcion: '2 (Dos) Pagos' },
  { codigo: 3, descripcion: '3 (Tres) Pagos' },
  { codigo: 4, descripcion: '4 (Cuatro) Pagos' },
  { codigo: 5, descripcion: '5 (Cinco) Pagos' }
];

const customValidator = (premioGs, premioUsd) => {
  const premioGsNumber = currencyToNumber(premioGs, {
    codigo: 'gs',
    simbolo: ''
  });
  const premioUsdNumber = currencyToNumber(premioUsd, {
    codigo: 'usd',
    simbolo: ''
  });
  if (premioGsNumber <= 0 && premioUsdNumber <= 0) {
    return Promise.reject(new Error('Debe definir un monto'));
  }
  return Promise.resolve();
};

const VigenciaConfigForm = ({
  model,
  onFinish,
  disabled,
  esEmpresa,
  vigencias,
  vigenciaHabilitadaIdList,
  setVigenciaHabilitadaIdList,
  modalidadHabilitadaIdList,
  setModalidadHabilitadaIdList
}) => {
  const [form] = Form.useForm();
  const [modalidades, setModalidades] = useState();
  const [emisionConUnidadMedida, setEmisionConUnidadMedida] = useState(null);
  const [tienePremio, setTienePremio] = useState(false);
  const [tienePromocion, setTienePromocion] = useState(false);
  const [tieneDescuento, setTieneDescuento] = useState(false);
  const [vigenciaSugeridaRadio, setVigenciaSugeridaRadio] = useState();
  const [frecuenciaSugeridaRadio, setFrecuenciaSugeridaRadio] = useState();
  const [mostrarErrorVigencia, setMostrarErrorVigencia] = useState();
  const [mostrarErrorFrecuencia, setMostrarErrorFrecuencia] = useState();
  const [cantidadPagosSugerida, setCantidadPagosSugerida] = useState();

  const handleChangeRadio = (e, setState) => {
    setState(e.target.value);
  };

  const getModelsByVigenciaIdList = (idList) => {
    return vigencias.filter((item) => {
      return idList.find((element) => element === item.id);
    });
  };
  const prepareData = (values) => {
    const calculoCostoParametros = form.getFieldValue(
      'calculo_costo_parametros'
    );

    const vigenciaPredeterminadaModel = vigencias.find(
      (item) => item.id === vigenciaSugeridaRadio
    );
    const vigenciaHabilitadaModelList = getModelsByVigenciaIdList(
      vigenciaHabilitadaIdList
    );
    const modalidadHabilitadaModelList = modalidades.filter((item) => {
      return modalidadHabilitadaIdList.find((element) => element === item.id);
    });
    const modalidadPredeterminadaModel = modalidades.find(
      (item) => item.id === frecuenciaSugeridaRadio
    );

    let modelToUpdate = {
      ...model,
      ...values,
      vigenciaHabilitadaModelList,
      modalidadHabilitadaModelList,
      calculo_costo_parametros: {
        ...calculoCostoParametros,
        premio_minimo_poliza_gs: tienePremio
          ? calculoCostoParametros.premio_minimo_poliza_gs
          : Number(0),
        premio_minimo_poliza_usd: tienePremio
          ? calculoCostoParametros.premio_minimo_poliza_usd
          : Number(0),
        promocion_contado: tienePromocion
          ? calculoCostoParametros.promocion_contado
          : null,
        tasa_descuento_pago_total_multianual: tieneDescuento
          ? calculoCostoParametros.tasa_descuento_pago_total_multianual
          : null
      }
    };

    if (esEmpresa) {
      modelToUpdate = {
        ...modelToUpdate,
        ...values,
        vigenciaPredeterminadaModel,
        modalidadPredeterminadaModel
        /* id_modalidad_pago_sugerida:
          modalidadPredeterminadaModel && modalidadPredeterminadaModel.id */
      };
      delete modelToUpdate.aseguradoraProductoVigencia;
      delete modelToUpdate.aseguradoraProductoModalidad;
    }

    return modelToUpdate;
  };

  const onSubmit = (values) => {
    const validationExtraFields = validateFields(values);
    if (validationExtraFields) {
      const data = prepareData(values);
      onFinish(data);
    }
  };

  const validarPeriodoCobertura = (values) => {
    /* Se obtienen los valores minimos y maximos en dias configurados en el Periodo de Cobertura */
    const unidadMedidaMinima = UNIDAD_MEDIDA_FECHAS.find(
      (item) => item.codigo === values.cobertura_min_unidad
    );
    const minimoCantidadDias = Number(
      values.cobertura_min_cantidad * unidadMedidaMinima.cantidad_dias
    );
    const unidadMedidaMaximo = UNIDAD_MEDIDA_FECHAS.find(
      (item) => item.codigo === values.cobertura_max_unidad
    );
    const maximoCantidadDias = Number(
      values.cobertura_max_cantidad * unidadMedidaMaximo.cantidad_dias
    );

    /* Se obtienen los valores minimos y maximos en dias de las Vigencias seleccionadas sugeridas */

    const vigenciaHabilitadaModelList = getModelsByVigenciaIdList(
      vigenciaHabilitadaIdList
    );
    const vigenciasHabilitadasOrdenadas = vigenciaHabilitadaModelList
      .map((item) => item.dias_vigencia)
      .sort((n1, n2) => n1 - n2);

    const habilitadaMenor = vigenciasHabilitadasOrdenadas[0];
    const habilitadaMayor =
      vigenciasHabilitadasOrdenadas[vigenciasHabilitadasOrdenadas.length - 1];

    /* Se realiza la comparacion de valores minimos y maximos permitidos entre las habilitadas y la configuracion de en el periodo */

    if (minimoCantidadDias > habilitadaMenor) {
      return false;
    }
    if (maximoCantidadDias < habilitadaMayor) {
      return false;
    }
    return true;
  };

  const validateFields = (values) => {
    if (esEmpresa && !vigenciaSugeridaRadio) {
      setMostrarErrorVigencia(true);
      onFinishFailed();
      return false;
    }

    if (
      esEmpresa &&
      modalidades &&
      modalidades.length > 0 &&
      !frecuenciaSugeridaRadio
    ) {
      setMostrarErrorFrecuencia(true);

      onFinishFailed();
      return false;
    }

    const periodoCoberturaValidado = validarPeriodoCobertura(values);
    if (!periodoCoberturaValidado) {
      message.warning(
        'Las Vigencias sugeridas se encuentran fuera del Periodo de Cobertura'
      );
      return false;
    }

    return true;
  };
  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const onChangeVigenciaCheck = (checkedValues) => {
    setVigenciaHabilitadaIdList(checkedValues);
    let existeSugeridaHabilitada = false;
    for (let i = 0; i < checkedValues.length; i += 1) {
      const item = checkedValues[i];
      if (item === vigenciaSugeridaRadio) {
        existeSugeridaHabilitada = true;
      }
    }
    if (!existeSugeridaHabilitada) {
      setVigenciaSugeridaRadio(null);
    }
  };

  const onChangeModalidadCheck = (checkedValues) => {
    setModalidadHabilitadaIdList(checkedValues);
  };

  const onChangeVigenciaRadio = (e) => {
    const { value } = e.target;
    setVigenciaSugeridaRadio(value);
  };

  const onChangeFrecuenciaRadio = (e) => {
    const { value } = e.target;
    setFrecuenciaSugeridaRadio(value);
  };

  const getModalidades = async () => {
    try {
      const response = await instanceRef.instance.get('/modalidad');
      const modalidadAllList = response.data?.data;
      if (modalidadAllList) {
        if (!esEmpresa) {
          setModalidades(ordenarFrecuencias(modalidadAllList));
        } else {
          const modalidadHabilitadas =
            model.aseguradoraProductoModalidad &&
            model.aseguradoraProductoModalidad.filter(
              (item) => item.habilitado
            );
          if (modalidadHabilitadas) {
            const modalidadHabilitadasModelList = modalidadHabilitadas
              .filter((habilitada) =>
                modalidadAllList.some(
                  (modalidad) => modalidad.id === habilitada.id_modalidad_pago
                )
              )
              .map((habilitada) => habilitada.modalidadPago);
            setModalidades(ordenarFrecuencias(modalidadHabilitadasModelList));
          }
        }
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const initValues = () => {
    form.setFieldsValue(model);
    if (
      model.calculo_costo_parametros.premio_minimo_poliza_gs ||
      model.calculo_costo_parametros.premio_minimo_poliza_usd
    ) {
      setTienePremio(true);
    }

    if (model.calculo_costo_parametros.promocion_contado) {
      setTienePromocion(true);
    }

    if (model.calculo_costo_parametros.tasa_descuento_pago_total_multianual) {
      setTieneDescuento(true);
    }

    if (
      model.emision_multiperiodo &&
      model.emision_multiperiodo === 'anual_renovable'
    ) {
      setEmisionConUnidadMedida(true);
    }

    let vigenciasHabilitadas = [];
    let modalidadHabilitadas = [];
    if (!esEmpresa) {
      vigenciasHabilitadas =
        model.aseguradoraProductoVigencia &&
        model.aseguradoraProductoVigencia.filter((item) => item.habilitado);

      modalidadHabilitadas =
        model.aseguradoraProductoModalidad &&
        model.aseguradoraProductoModalidad.filter((item) => item.habilitado);
    } else {
      vigenciasHabilitadas =
        model.empresaProductoVigencia &&
        model.empresaProductoVigencia.filter((item) => item.habilitado);

      modalidadHabilitadas =
        model.empresaProductoModalidad &&
        model.empresaProductoModalidad.filter((item) => item.habilitado);

      const sugeridaVigencia =
        model.empresaProductoVigencia &&
        model.empresaProductoVigencia.find((item) => item.predeterminado);

      if (sugeridaVigencia) {
        setVigenciaSugeridaRadio(sugeridaVigencia.id_vigencia_pago);
      }

      const sugeridaModalidad =
        model.empresaProductoModalidad &&
        model.empresaProductoModalidad.find((item) => item.predeterminado);
      if (sugeridaModalidad) {
        setFrecuenciaSugeridaRadio(sugeridaModalidad.id_modalidad_pago);
      }
    }

    if (vigenciasHabilitadas && vigenciasHabilitadas.length > 0) {
      setVigenciaHabilitadaIdList(
        vigenciasHabilitadas.map((item) => item.id_vigencia_pago)
      );
    }

    if (modalidadHabilitadas && modalidadHabilitadas.length > 0) {
      setModalidadHabilitadaIdList(
        modalidadHabilitadas.map((item) => item.id_modalidad_pago)
      );
    }
  };

  const getDescripcion = () => {
    const cantidad = form.getFieldValue('cobertura_max_cantidad');
    const unidadMedida =
      (form.getFieldValue('cobertura_max_unidad') &&
        UNIDAD_MEDIDA_FECHAS.filter(
          (item) => item.codigo === form.getFieldValue('cobertura_max_unidad')
        )[0].descripcion) ||
      '';
    return `${cantidad} ${unidadMedida}`;
  };

  useEffect(() => {
    if (
      modalidades &&
      vigencias &&
      vigenciaSugeridaRadio &&
      frecuenciaSugeridaRadio
    ) {
      const modalidadSug = modalidades.find(
        (item) => item.id === Number(frecuenciaSugeridaRadio)
      );

      const vigenciaSug = vigencias.find(
        (item) => item.id === Number(vigenciaSugeridaRadio)
      );
      let cantidad = CANTIDAD_PAGOS_TODOS.find((item) => item.codigo === 1);
      if (
        modalidadSug.codigo === 'total' ||
        modalidadSug.codigo === vigenciaSug.codigo
      ) {
        cantidad = CANTIDAD_PAGOS_TODOS.find((item) => item.codigo === 1);
        setCantidadPagosSugerida(cantidad.codigo);
        form.setFieldsValue({
          cantidad_pagos_sugerida: cantidad.codigo
        });
      } else if (
        modalidadSug.codigo === 'mensual' &&
        vigenciaSug.codigo !== 'semanal'
      ) {
        cantidad = CANTIDAD_PAGOS_TODOS.find(
          (item) => item.codigo === vigenciaSug.multiplicador
        );
        setCantidadPagosSugerida(cantidad.codigo);

        form.setFieldsValue({
          cantidad_pagos_sugerida: cantidad.codigo
        });
      } else if (vigenciaSug.multiplicador > modalidadSug.multiplicador) {
        cantidad = vigenciaSug.multiplicador / modalidadSug.multiplicador;
        setCantidadPagosSugerida(cantidad);

        form.setFieldsValue({
          cantidad_pagos_sugerida: cantidad
        });
      } else {
        setCantidadPagosSugerida(cantidad.codigo);

        form.setFieldsValue({
          cantidad_pagos_sugerida: cantidad.codigo
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaSugeridaRadio, frecuenciaSugeridaRadio]);

  useEffect(() => {
    setMostrarErrorVigencia(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vigenciaSugeridaRadio]);

  useEffect(() => {
    initValues();
    getModalidades();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Form
      name="vigencia"
      layout="vertical"
      scrollToFirstError
      onFinish={onSubmit}
      onFinishFailed={() => onFinishFailed()}
      form={form}
      noValidate
    >
      <Title level={5}>Periodo de Cobertura</Title>
      <Row gutter={[16, 0]} style={{ textAlign: 'start', alignItems: 'end' }}>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Cantidad Máxima"
            name="cobertura_max_cantidad"
            rules={[{ required: true }]}
            onKeyPress={formatNumberOnKeyPress}
            disabled={disabled}
          >
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Unidad de Medida"
            name="cobertura_max_unidad"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir Opción"
              disabled={disabled}
            >
              {UNIDAD_MEDIDA_FECHAS.map(({ codigo, descripcion }) => (
                <Option key={codigo} value={codigo}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 0]} style={{ textAlign: 'start', alignItems: 'end' }}>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Cantidad Mínima"
            name="cobertura_min_cantidad"
            rules={[{ required: true }]}
            style={{ width: '100%' }}
            onKeyPress={formatNumberOnKeyPress}
          >
            <InputNumber
              step={1}
              min={0}
              style={{ width: '100%' }}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Unidad de Medida"
            name="cobertura_min_unidad"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir Opción"
              disabled={disabled}
            >
              {UNIDAD_MEDIDA_FECHAS.map(({ codigo, descripcion }) => (
                <Option key={codigo} value={codigo}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 0]} style={{ textAlign: 'start', alignItems: 'end' }}>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Retroactividad hasta"
            name="retroactividad_cantidad"
            rules={[{ required: true }]}
            onKeyPress={formatNumberOnKeyPress}
          >
            <InputNumber
              step={1}
              min={0}
              style={{ width: '100%' }}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Unidad de Medida"
            name="retroactividad_unidad"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir Opción"
              disabled={disabled}
            >
              {UNIDAD_MEDIDA_FECHAS.map(({ codigo, descripcion }) => (
                <Option key={codigo} value={codigo}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 0]} style={{ textAlign: 'start', alignItems: 'end' }}>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Agendamiento de Inicio de Vigencia hasta"
            name="agendamiento_max_vigencia_cantidad"
            rules={[{ required: true }]}
            onKeyPress={formatNumberOnKeyPress}
          >
            <InputNumber
              step={1}
              min={0}
              style={{ width: '100%' }}
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          <Form.Item
            label="Unidad de Medida"
            name="agendamiento_max_vigencia_unidad"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir Opción"
              disabled={disabled}
            >
              {UNIDAD_MEDIDA_FECHAS.map(({ codigo, descripcion }) => (
                <Option key={codigo} value={codigo}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <br />
      <Title level={5}>Vigencias sugeridas para Cotizaciones</Title>
      <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
        <Col xs={24} sm={8} md={6}>
          <Label>Habilitadas</Label>
        </Col>
        {esEmpresa && (
          <Col xs={24} sm={8} md={6}>
            <ValidateMessage required />
            <Label>Sugerida</Label>
            {mostrarErrorVigencia && (
              <LabelValidateMessage message="La Vigencia Sugerida es un campo requerido" />
            )}
          </Col>
        )}
      </Row>
      {vigencias && vigencias.length > 0 && vigenciaHabilitadaIdList && (
        <>
          <Checkbox.Group
            style={{
              width: '100%',
              display: 'block'
            }}
            value={vigenciaHabilitadaIdList}
            onChange={onChangeVigenciaCheck}
          >
            {vigencias &&
              vigencias.map(({ id, descripcion }) => (
                <Row gutter={[16, 0]} style={{ textAlign: 'start' }} key={id}>
                  <Col xs={24} sm={8} md={6}>
                    <Checkbox value={id} disabled={disabled}>
                      {descripcion}
                    </Checkbox>
                  </Col>

                  {esEmpresa && (
                    <Col xs={24} sm={8} md={6}>
                      <Radio.Group
                        onChange={onChangeVigenciaRadio}
                        value={vigenciaSugeridaRadio}
                        disabled={
                          disabled ||
                          !vigenciaHabilitadaIdList.find((item) => item === id)
                        }
                      >
                        <Radio value={id} />
                      </Radio.Group>
                    </Col>
                  )}
                </Row>
              ))}
          </Checkbox.Group>
          <br />
          <br />
        </>
      )}

      <Title level={5}>Frecuencias sugeridas para Cotizaciones</Title>
      <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
        {modalidades && modalidades.length > 0 ? (
          <>
            <Col xs={24} sm={8} md={6}>
              <Label>Habilitadas</Label>
            </Col>
            {esEmpresa && (
              <Col xs={24} sm={8} md={6}>
                <ValidateMessage required />
                <Label>Sugerida</Label>
                {mostrarErrorFrecuencia && (
                  <LabelValidateMessage message="La Frecuencia Sugerida es un campo requerido" />
                )}
              </Col>
            )}
          </>
        ) : (
          <p>No existen frecuencias habilitadas por la Aseguradora</p>
        )}
      </Row>
      {modalidades && modalidades.length > 0 && (
        <>
          <Checkbox.Group
            style={{
              width: '100%',
              display: 'block'
            }}
            value={modalidadHabilitadaIdList}
            onChange={onChangeModalidadCheck}
          >
            {modalidades &&
              modalidades.map(({ id, descripcion, multiplicador }) => (
                <Row gutter={[16, 0]} style={{ textAlign: 'start' }} key={id}>
                  <Col xs={24} sm={8} md={6}>
                    <Checkbox value={id} disabled={disabled}>
                      {descripcion}
                    </Checkbox>
                  </Col>
                  {esEmpresa && (
                    <Col xs={24} sm={8} md={6}>
                      <Radio.Group
                        onChange={onChangeFrecuenciaRadio}
                        value={frecuenciaSugeridaRadio}
                        disabled={
                          disabled ||
                          (modalidadHabilitadaIdList &&
                            !modalidadHabilitadaIdList.find(
                              (item) => item === id
                            )) ||
                          (vigenciaSugeridaRadio &&
                            multiplicador >
                              vigencias.find(
                                (item) => item.id === vigenciaSugeridaRadio
                              ).multiplicador)
                        }
                      >
                        <Radio value={id} />
                      </Radio.Group>
                    </Col>
                  )}
                </Row>
              ))}
          </Checkbox.Group>
          <br />
          {esEmpresa && (
            <>
              <br />
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={24} sm={8} md={6}>
                  {/* <Form.Item
                    label="Cantidad de Pagos (Sugerida)"
                    name="cantidad_pagos_sugerida"
                    rules={[{ required: true }]}
                  >
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Elegir Opción"
                      disabled={disabled}
                      // onChange={(value) => onChangeCantidadPagos(value)}
                    >
                      {cantidadPagosList.map(({ codigo, descripcion }) => (
                        <Option key={codigo} value={codigo}>
                          {descripcion}
                        </Option>
                      ))}
                    </Select>
                    <Col xs={24}>


                  </Form.Item> */}
                  <Form.Item
                    label="Cantidad de Pagos"
                    name="cantidad_pagos_sugerida"
                    rules={[{ required: true }]}
                    // initialValue={cantidadPagosSugerida}
                  >
                    <Input
                      readOnly
                      bordered={false}
                      value={cantidadPagosSugerida}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </>
      )}
      <br />
      <br />
      <Title level={5}>Forma de Emisión</Title>
      <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item
            label="Emisión"
            name="emision_multiperiodo"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir Opción"
              onChange={(val) => {
                if (val === 'anual_renovable') {
                  setEmisionConUnidadMedida(true);
                } else {
                  setEmisionConUnidadMedida(false);
                }
              }}
              disabled={disabled}
            >
              {FORMAS_EMISION.map(({ codigo, descripcion }) => (
                <Option key={codigo} value={codigo}>
                  {codigo === 'multi_anual'
                    ? `${descripcion} (${getDescripcion()})`
                    : descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={12} sm={8} md={6}>
          {emisionConUnidadMedida && (
            <Form.Item label="Unidad de Medida" rules={[{ required: true }]}>
              <Select
                style={{ width: '100%' }}
                placeholder="Elegir Opción"
                disabled={disabled}
              >
                {UNIDAD_MEDIDA_FECHAS.map(({ codigo, descripcion }) => (
                  <Option key={codigo} value={codigo}>
                    {descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </Col>
      </Row>
      <br />
      <Title level={5}>Parámetros del Cálculo Costo</Title>
      <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item
            label="Recargo por Periodo Corto"
            name={['calculo_costo_parametros', 'recargo_periodo_corto']}
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '100%' }}
              placeholder="Elegir Opción"
              disabled={disabled}
            >
              {PERIODOS_CORTOS.map(({ codigo, descripcion }) => (
                <Option key={codigo} value={codigo}>
                  {descripcion}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 8]} style={{ textAlign: 'start' }}>
        <Col xs={24} sm={8} md={6}>
          <Label>Premio Mínimo por Póliza</Label>
        </Col>
        <Col xs={24} sm={8} md={6}>
          <Radio.Group
            onChange={(e) => handleChangeRadio(e, setTienePremio)}
            value={tienePremio}
            disabled={disabled}
          >
            <Space direction="">
              <Radio value>Si</Radio>
              <Radio value={false}>No</Radio>
            </Space>
          </Radio.Group>
        </Col>
        <Col xs={24}>
          <Row>
            <Col xs={24} sm={8} md={6}>
              {tienePremio ? (
                <>
                  <table
                    style={{
                      textAlign: 'end',
                      width: '100%',
                      borderRadius: 6,
                      border: `1px solid ${borderSolid}`
                    }}
                    className="table"
                  >
                    <tbody>
                      <tr>
                        <td style={tableTitleStyle()} className="sticky-header">
                          Guaraní (Gs)
                        </td>
                        <td style={tableTitleStyle()} className="sticky-header">
                          Dolar Estadounidense (USD)
                        </td>
                      </tr>
                      <tr>
                        <td style={{ paddingLeft: 8, paddingRight: 8 }}>
                          <Form.Item
                            label="Premio Mínimo por Póliza"
                            name={[
                              'calculo_costo_parametros',
                              'premio_minimo_poliza_gs'
                            ]}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator() {
                                  return customValidator(
                                    getFieldValue([
                                      'calculo_costo_parametros',
                                      'premio_minimo_poliza_gs'
                                    ]),
                                    getFieldValue([
                                      'calculo_costo_parametros',
                                      'premio_minimo_poliza_usd'
                                    ])
                                  );
                                }
                              })
                            ]}
                            noStyle
                          >
                            <CurrencyInputCustom
                              readOnly={disabled}
                              moneda={{ codigo: 'gs', simbolo: '' }}
                            />
                          </Form.Item>
                        </td>
                        <td style={{ paddingLeft: 8, paddingRight: 8 }}>
                          <Form.Item
                            label="Premio Mínimo por Póliza"
                            name={[
                              'calculo_costo_parametros',
                              'premio_minimo_poliza_usd'
                            ]}
                            rules={[
                              ({ getFieldValue }) => ({
                                validator() {
                                  return customValidator(
                                    getFieldValue([
                                      'calculo_costo_parametros',
                                      'premio_minimo_poliza_gs'
                                    ]),
                                    getFieldValue([
                                      'calculo_costo_parametros',
                                      'premio_minimo_poliza_usd'
                                    ])
                                  );
                                }
                              })
                            ]}
                            noStyle
                          >
                            <CurrencyInputCustom
                              moneda={{ codigo: 'usd', simbolo: '' }}
                            />
                          </Form.Item>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <Form.Item noStyle shouldUpdate>
                    {() => {
                      return (
                        <LabelValidateMessage
                          message={
                            form.getFieldError([
                              'calculo_costo_parametros',
                              'premio_minimo_poliza_gs'
                            ])?.[0] ||
                            form.getFieldError([
                              'calculo_costo_parametros',
                              'premio_minimo_poliza_usd'
                            ])?.[0] ||
                            ''
                          }
                        />
                      );
                    }}
                  </Form.Item>
                </>
              ) : (
                <span />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item
            label="Promoción Contado"
            name={['calculo_costo_parametros', 'promocion_contado']}
            rules={[{ required: tienePromocion }]}
            onKeyPress={formatNumberOnKeyPress}
          >
            {tienePromocion ? (
              <Select
                style={{ width: '100%' }}
                placeholder="Elegir Opción"
                // value={0}
                disabled={disabled}
              >
                {OPCIONES_CANTIDAD_PROMOCION.map(({ codigo, descripcion }) => (
                  <Option key={codigo} value={codigo}>
                    {descripcion}
                  </Option>
                ))}
              </Select>
            ) : (
              <Select style={{ display: 'none' }} />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={6}>
          <Radio.Group
            onChange={(e) => handleChangeRadio(e, setTienePromocion)}
            value={tienePromocion}
            disabled={disabled}
          >
            <Space direction="">
              <Radio value>Si</Radio>
              <Radio value={false}>No</Radio>
            </Space>
          </Radio.Group>
          <br />
          <br />
          {tienePromocion && (
            <Label>Pagos mensuales, iguales y consecutivos</Label>
          )}
        </Col>
      </Row>
      <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item
            label="Tasa de Descuento por Pago Total de Vigencia Multi-Anual"
            name={[
              'calculo_costo_parametros',
              'tasa_descuento_pago_total_multianual'
            ]}
            rules={[{ required: tieneDescuento }]}
            onKeyPress={formatNumberOnKeyPress}
          >
            {tieneDescuento ? (
              <InputNumber
                step={1}
                min={0}
                style={{ width: '100%' }}
                formatter={(value) => `${value}%`}
                parser={(value) => {
                  const valueNumber = Number(value.replace('%', ''));
                  return `${Math.trunc(valueNumber)}`;
                }}
                disabled={disabled}
              />
            ) : (
              <InputNumber style={{ display: 'none' }} />
            )}
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={6}>
          <Radio.Group
            onChange={(e) => handleChangeRadio(e, setTieneDescuento)}
            value={tieneDescuento}
            disabled={disabled}
          >
            <Space direction="">
              <Radio value>Si</Radio>
              <Radio value={false}>No</Radio>
            </Space>
          </Radio.Group>
        </Col>
      </Row>
      <br />
      <Button
        type="primary"
        htmlType="submit"
        icon={<SaveOutlined />}
        disabled={disabled}
      >
        Guardar
      </Button>
    </Form>
  );
};

export default VigenciaConfigForm;
